"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveNode = void 0;
const react_1 = __importStar(require("react"));
const graphql_zeus_1 = require("graphql-zeus");
const index_1 = require("../Field/index");
const index_2 = require("../Directive/index");
const index_3 = require("../InputValue/index");
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../Colors");
const constants_1 = require("../../constants");
const theme_1 = require("../../../editor/theme");
const index_4 = require("../../DOM/index");
const index_5 = require("../Type/index");
const SharedNode_1 = require("../SharedNode");
const index_6 = require("../components/index");
const trees_1 = require("../../../state/containers/trees");
const TopNodeMenu_1 = require("./TopNodeMenu");
const index_7 = require("../../../GraphQL/Resolve/index");
const index_8 = require("../Argument/index");
const fadeIn = typestyle_1.keyframes({
    ['0%']: {
        opacity: 0.0,
    },
    ['100%']: {
        opacity: 1.0,
    },
});
const LeftNodeArea = {
    position: 'absolute',
    left: -300,
    width: 300,
    zIndex: 4,
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
};
const LeftNodeAreaNode = { position: 'relative' };
const RightNodeArea = { position: 'absolute', right: -300, width: 300, zIndex: 4 };
const RightNodeAreaNode = { position: 'absolute' };
const LibraryNodeArea = {
    borderStyle: 'dashed',
};
const MainNodeArea = {
    position: 'relative',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 4,
    maxWidth: 600,
    transition: `border-color .25s ease-in-out`,
    borderColor: Colors_1.Colors.green[0],
    $nest: {
        '.NodeTitle': SharedNode_1.NodeTitle,
        '.NodeFields': SharedNode_1.NodeFields,
        '&.LibraryNodeArea': LibraryNodeArea,
    },
};
const DescriptionPosition = {
    position: 'absolute',
    transformOrigin: 'center bottom',
    transform: 'translate(0px, calc(-100% - 10px))',
    width: '100%',
    outline: 'none',
    $nest: {
        '&:focus': {
            border: `1px solid ${Colors_1.Colors.grey[3]}`,
        },
    },
};
const NodeContainer = typestyle_1.style({
    position: 'relative',
    breakInside: 'avoid',
    maxWidth: '100%',
    margin: 10,
    $nest: Object.assign(Object.assign({ '.DescriptionPosition': DescriptionPosition, '.LeftNodeArea': LeftNodeArea, '.RightNodeArea': RightNodeArea, '.MainNodeArea': Object.assign(Object.assign({}, MainNodeArea), { animationName: fadeIn, animationDuration: '0.25s' }), '.RightNodeAreaNode': RightNodeAreaNode, '.LeftNodeAreaNode': LeftNodeAreaNode, '&:hover': {
            $nest: {
                '> .ActionsMenu': {
                    opacity: 1.0,
                    pointerEvents: 'auto',
                },
            },
        } }, Object.keys(theme_1.GraphQLBackgrounds).reduce((a, b) => {
        a[`.NodeBackground-${b}`] = {
            background: theme_1.GraphQLBackgrounds[b],
        };
        return a;
    }, {})), Object.keys(theme_1.GraphQLBackgrounds).reduce((a, b) => {
        a[`.NodeType-${b}`] = {
            background: theme_1.GraphQLBackgrounds[b],
            $nest: {
                '&:hover, &.Active': {
                    background: Colors_1.mix(theme_1.GraphQLBackgrounds[b], Colors_1.Colors.grey[0], 80),
                },
            },
        };
        return a;
    }, {})),
});
const NodeInterfaces = typestyle_1.style({
    maxWidth: 600,
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    marginBottom: 5,
});
exports.ActiveNode = (_a) => {
    var _b, _c, _d;
    var { node } = _a, sharedProps = __rest(_a, ["node"]);
    const [openedInputs, setOpenedInputs] = react_1.useState([]);
    const [openedOutputs, setOpenedOutputs] = react_1.useState([]);
    const [openedDirectiveInputs, setOpenedDirectiveInputs] = react_1.useState([]);
    const [openedDirectiveOutputs, setOpenedDirectiveOutputs] = react_1.useState([]);
    const { libraryTree, tree, setTree, setSelectedNode, selectedNode, selectedNodeRef } = trees_1.useTreesState();
    const isLibrary = !!libraryTree.nodes.find((lN) => lN.name === node.name && lN.data.type === node.data.type);
    const isInputNode = [
        graphql_zeus_1.TypeSystemDefinition.FieldDefinition,
        graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition,
        graphql_zeus_1.TypeDefinition.InputObjectTypeDefinition,
        graphql_zeus_1.TypeExtension.InputObjectTypeExtension,
        graphql_zeus_1.Instances.Directive,
    ].includes(node.data.type);
    const isArgumentNode = [graphql_zeus_1.Instances.Directive].includes(node.data.type);
    const parentNode = tree.nodes.find((n) => n.name === node.type.name);
    const isLocked = !!sharedProps.readonly || isLibrary;
    const findNodeByField = (field) => {
        return (tree.nodes.find((n) => n.name === field.type.name && !index_7.isExtensionNode(n.data.type)) ||
            libraryTree.nodes.find((n) => n.name === field.type.name && !index_7.isExtensionNode(n.data.type)));
    };
    return (react_1.default.createElement("div", { className: `${NodeContainer} ${index_4.DOM.classes.node} ${index_4.DOM.classes.nodeSelected}`, ref: selectedNodeRef },
        react_1.default.createElement(index_6.ActiveDescription, { className: 'DescriptionPosition', onChange: (d) => {
                node.description = d;
                setTree(Object.assign({}, tree));
            }, isLocked: isLocked, value: node.description || '' }),
        !!((_b = node.interfaces) === null || _b === void 0 ? void 0 : _b.length) && (react_1.default.createElement("div", { className: NodeInterfaces }, node.interfaces.map((i) => (react_1.default.createElement(index_6.NodeInterface, { key: i, isLocked: isLocked, onDelete: () => {
                var _a;
                node.interfaces = (_a = node.interfaces) === null || _a === void 0 ? void 0 : _a.filter((oldInterface) => oldInterface !== i);
                setTree(Object.assign({}, tree));
            } }, i))))),
        react_1.default.createElement("div", { className: `LeftNodeArea` },
            openedDirectiveInputs.sort().map((o) => (react_1.default.createElement("div", { key: o, className: `LeftNodeAreaNode`, style: { top: constants_1.FIELD_HEIGHT * (o + 1) } },
                react_1.default.createElement(exports.ActiveNode, Object.assign({}, sharedProps, { readonly: isLocked, node: node.directives[o], onDelete: () => {
                        setOpenedDirectiveInputs([]);
                        setOpenedDirectiveOutputs([]);
                        node.directives.splice(o, 1);
                        index_4.DOM.panLock = false;
                        setTree(Object.assign({}, tree));
                    } }))))),
            openedInputs.sort().map((o) => {
                var _a;
                return (react_1.default.createElement("div", { key: o, className: `LeftNodeAreaNode`, style: { top: constants_1.FIELD_HEIGHT * (o + (((_a = node.directives) === null || _a === void 0 ? void 0 : _a.length) || 0) + 1) } },
                    react_1.default.createElement(exports.ActiveNode, Object.assign({}, sharedProps, { readonly: isLocked, node: node.args[o], onDelete: () => {
                            setOpenedInputs([]);
                            setOpenedOutputs([]);
                            node.args.splice(o, 1);
                            index_4.DOM.panLock = false;
                            setTree(Object.assign({}, tree));
                        } }))));
            })),
        react_1.default.createElement("div", { className: `RightNodeArea` },
            openedDirectiveOutputs.sort().map((o) => (react_1.default.createElement("div", { key: o, className: `RightNodeAreaNode`, style: { top: constants_1.FIELD_HEIGHT * (o + 1) } },
                react_1.default.createElement(exports.ActiveNode, Object.assign({}, sharedProps, { readonly: isLocked, node: findNodeByField(node.directives[o]) }))))),
            openedOutputs.sort().map((o) => {
                var _a;
                return (react_1.default.createElement("div", { key: o, className: `RightNodeAreaNode`, style: { top: constants_1.FIELD_HEIGHT * (o + (((_a = node.directives) === null || _a === void 0 ? void 0 : _a.length) || 0) + 1) } },
                    react_1.default.createElement(exports.ActiveNode, Object.assign({}, sharedProps, { readonly: isLocked, node: findNodeByField(node.args[o]) }))));
            })),
        react_1.default.createElement("div", { className: `MainNodeArea${isLibrary ? ' LibraryNodeArea' : ''}`, onClick: (e) => {
                e.stopPropagation();
            } },
            react_1.default.createElement("div", { className: `NodeTitle` },
                react_1.default.createElement("div", { className: `NodeName` },
                    isLocked && react_1.default.createElement(index_6.EditableText, { value: node.name }),
                    !isLocked && (react_1.default.createElement(index_6.EditableText, { fontSize: 12, value: node.name, onChange: (v) => {
                            index_7.ChangeAllRelatedNodes({
                                newName: v,
                                nodes: tree.nodes,
                                oldName: node.name,
                            });
                            const reselect = node.name === (selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.name);
                            node.name = v;
                            setTree(Object.assign({}, tree));
                            if (reselect && selectedNode) {
                                setSelectedNode({
                                    name: v,
                                    data: node.data,
                                    type: node.type,
                                });
                            }
                        } }))),
                react_1.default.createElement("div", { className: `NodeType` },
                    react_1.default.createElement(index_5.ActiveType, { type: node.type })),
                !isLocked && react_1.default.createElement(TopNodeMenu_1.TopNodeMenu, Object.assign({}, sharedProps, { node: node }))),
            react_1.default.createElement("div", { className: `NodeFields NodeBackground-${parentNode ? parentNode.type.name : node.type.name}` }, (_c = node.directives) === null || _c === void 0 ? void 0 :
                _c.map((d, i) => {
                    var _a;
                    const outputDisabled = !(tree.nodes.find((n) => n.name === d.type.name) || libraryTree.nodes.find((n) => n.name === d.type.name));
                    return (react_1.default.createElement(index_2.ActiveDirective, { isLocked: isLocked, parentNodeTypeName: node.type.name, last: i === (((_a = node.args) === null || _a === void 0 ? void 0 : _a.length) || 0) - 1, key: d.name, onInputClick: () => {
                            setOpenedDirectiveInputs((oI) => (oI.includes(i) ? oI.filter((o) => o !== i) : [...oI, i]));
                        }, onOutputClick: () => {
                            setOpenedDirectiveOutputs((oO) => (oO.includes(i) ? oO.filter((o) => o !== i) : [...oO, i]));
                        }, node: d, inputOpen: openedDirectiveInputs.includes(i), outputDisabled: outputDisabled, outputOpen: openedDirectiveOutputs.includes(i), onDelete: () => {
                            setOpenedDirectiveInputs([]);
                            setOpenedDirectiveOutputs([]);
                            node.directives.splice(i, 1);
                            index_4.DOM.panLock = false;
                            setTree(Object.assign({}, tree));
                        } }));
                }), (_d = node.args) === null || _d === void 0 ? void 0 :
                _d.map((a, i) => {
                    const outputDisabled = !(tree.nodes.find((n) => n.name === a.type.name) || libraryTree.nodes.find((n) => n.name === a.type.name));
                    if (isArgumentNode) {
                        return (react_1.default.createElement(index_8.ActiveArgument, { parentNode: node, isLocked: isLocked, parentNodeTypeName: node.type.name, last: i === node.args.length - 1, key: a.name, onInputClick: () => {
                                setOpenedInputs((oI) => (oI.includes(i) ? oI.filter((o) => o !== i) : [...oI, i]));
                            }, onOutputClick: () => {
                                setOpenedOutputs((oO) => (oO.includes(i) ? oO.filter((o) => o !== i) : [...oO, i]));
                            }, node: a, inputOpen: openedInputs.includes(i), outputDisabled: outputDisabled, outputOpen: openedOutputs.includes(i), onDelete: () => {
                                node.args.splice(i, 1);
                                index_4.DOM.panLock = false;
                                setTree(Object.assign({}, tree));
                            } }));
                    }
                    if (isInputNode) {
                        return (react_1.default.createElement(index_3.ActiveInputValue, { isLocked: isLocked, parentNodeTypeName: node.type.name, last: i === node.args.length - 1, key: a.name, onInputClick: () => {
                                setOpenedInputs((oI) => (oI.includes(i) ? oI.filter((o) => o !== i) : [...oI, i]));
                            }, onOutputClick: () => {
                                setOpenedOutputs((oO) => (oO.includes(i) ? oO.filter((o) => o !== i) : [...oO, i]));
                            }, node: a, inputOpen: openedInputs.includes(i), outputDisabled: outputDisabled, outputOpen: openedOutputs.includes(i), onDelete: () => {
                                node.args.splice(i, 1);
                                index_4.DOM.panLock = false;
                                setTree(Object.assign({}, tree));
                            } }));
                    }
                    return (react_1.default.createElement(index_1.ActiveField, { isLocked: isLocked, parentNodeTypeName: node.type.name, last: i === node.args.length - 1, key: a.name, onInputClick: () => {
                            setOpenedInputs((oI) => (oI.includes(i) ? oI.filter((o) => o !== i) : [...oI, i]));
                        }, onOutputClick: () => {
                            setOpenedOutputs((oO) => (oO.includes(i) ? oO.filter((o) => o !== i) : [...oO, i]));
                        }, node: a, inputOpen: openedInputs.includes(i), outputDisabled: outputDisabled, outputOpen: openedOutputs.includes(i), onDelete: () => {
                            node.args.splice(i, 1);
                            index_4.DOM.panLock = false;
                            setTree(Object.assign({}, tree));
                        } }));
                })))));
};
